(() => {
  if (window.OPSportReminders) return;

  const KEY = 'op_sport_reminders_v1';
  const lang = (document.documentElement.lang || 'fr').toLowerCase().split('-')[0];
  const I18N = {
    fr:{champOn:'Rappels championnat activés',eventOn:'Rappel activé',champOff:'Activer les rappels',eventOff:'Activer un rappel',champDisabled:'Rappels championnat désactivés.',eventDisabled:'Rappel désactivé.',before:'avant',day7:'7 jours',eventFeedback:'Touchez « Ajouter au calendrier » pour l’importer dans votre agenda avec cette alerte.',champFeedback:'Exportez Mon calendrier sportif pour les ajouter à votre agenda.',leadChanged:'Délai de rappel réglé sur'},
    en:{champOn:'Championship reminders enabled',eventOn:'Reminder enabled',champOff:'Enable reminders',eventOff:'Enable reminder',champDisabled:'Championship reminders disabled.',eventDisabled:'Reminder disabled.',before:'before',day7:'7 days',eventFeedback:'Tap “Add to calendar” to import it into your calendar with this alert.',champFeedback:'Export My motorsport calendar to add them to your calendar.',leadChanged:'Reminder lead time set to'},
    de:{champOn:'Meisterschaftserinnerungen aktiviert',eventOn:'Erinnerung aktiviert',champOff:'Erinnerungen aktivieren',eventOff:'Erinnerung aktivieren',champDisabled:'Meisterschaftserinnerungen deaktiviert.',eventDisabled:'Erinnerung deaktiviert.',before:'vorher',day7:'7 Tage',eventFeedback:'Tippen Sie auf „Zum Kalender hinzufügen“, um den Termin mit dieser Erinnerung zu importieren.',champFeedback:'Exportieren Sie „Mein Motorsportkalender“, um die Termine Ihrem Kalender hinzuzufügen.',leadChanged:'Erinnerungszeit eingestellt auf'},
    es:{champOn:'Recordatorios del campeonato activados',eventOn:'Recordatorio activado',champOff:'Activar recordatorios',eventOff:'Activar recordatorio',champDisabled:'Recordatorios del campeonato desactivados.',eventDisabled:'Recordatorio desactivado.',before:'antes',day7:'7 días',eventFeedback:'Toca «Añadir al calendario» para importarlo en tu calendario con esta alerta.',champFeedback:'Exporta Mi calendario de motor para añadirlos a tu calendario.',leadChanged:'Antelación del recordatorio establecida en'},
    it:{champOn:'Promemoria campionato attivati',eventOn:'Promemoria attivato',champOff:'Attiva promemoria',eventOff:'Attiva un promemoria',champDisabled:'Promemoria campionato disattivati.',eventDisabled:'Promemoria disattivato.',before:'prima',day7:'7 giorni',eventFeedback:'Tocca «Aggiungi al calendario» per importarlo nel calendario con questo avviso.',champFeedback:'Esporta Il mio calendario motorsport per aggiungerli al calendario.',leadChanged:'Anticipo promemoria impostato su'},
    nl:{champOn:'Kampioenschapsherinneringen ingeschakeld',eventOn:'Herinnering ingeschakeld',champOff:'Herinneringen inschakelen',eventOff:'Herinnering inschakelen',champDisabled:'Kampioenschapsherinneringen uitgeschakeld.',eventDisabled:'Herinnering uitgeschakeld.',before:'vooraf',day7:'7 dagen',eventFeedback:'Tik op ‘Aan kalender toevoegen’ om het met deze melding in je kalender te importeren.',champFeedback:'Exporteer Mijn motorsportkalender om ze aan je kalender toe te voegen.',leadChanged:'Herinneringstijd ingesteld op'}
  };
  const tr = I18N[lang] || I18N.fr;
  const DEFAULT_LEAD = 1440;
  const empty = () => ({ events: [], championships: [], leadMinutes: DEFAULT_LEAD });

  const read = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!raw || typeof raw !== 'object') return empty();
      return {
        events: Array.isArray(raw.events) ? raw.events : [],
        championships: Array.isArray(raw.championships) ? raw.championships : [],
        leadMinutes: Number(raw.leadMinutes) > 0 ? Number(raw.leadMinutes) : DEFAULT_LEAD
      };
    } catch (_) {
      return empty();
    }
  };

  const write = (data) => {
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (_) {}
    window.dispatchEvent(new CustomEvent('op:sport-reminders-changed', { detail: data }));
  };

  const has = (type, id) => {
    if (!id) return false;
    const data = read();
    return (type === 'championship' ? data.championships : data.events).includes(id);
  };

  const toggle = (type, id) => {
    if (!id) return false;
    const data = read();
    const key = type === 'championship' ? 'championships' : 'events';
    const set = new Set(data[key]);
    const active = !set.has(id);
    if (active) set.add(id);
    else set.delete(id);
    data[key] = Array.from(set);
    write(data);
    return active;
  };

  const setLeadMinutes = (value) => {
    const lead = Number(value);
    if (!Number.isFinite(lead) || lead <= 0) return;
    const data = read();
    data.leadMinutes = lead;
    write(data);
  };

  const syncButton = (button) => {
    const type = button.hasAttribute('data-reminder-championship') ? 'championship' : 'event';
    const id = button.dataset.reminderId || '';
    const active = has(type, id);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.classList.toggle('is-active', active);
    const icon = button.querySelector('[data-reminder-icon]');
    if (icon) icon.textContent = active ? '🔔' : '♢';
    const label = button.querySelector('[data-reminder-label]');
    if (label) {
      label.textContent = active
        ? (type === 'championship' ? tr.champOn : tr.eventOn)
        : (type === 'championship' ? tr.champOff : tr.eventOff);
    }
  };

  const showFeedback = (message) => {
    let toast = document.querySelector('[data-op-reminder-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('data-op-reminder-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      Object.assign(toast.style, {
        position: 'fixed',
        left: '50%',
        bottom: '24px',
        transform: 'translateX(-50%)',
        zIndex: '99999',
        maxWidth: 'calc(100vw - 32px)',
        padding: '12px 16px',
        borderRadius: '12px',
        background: '#083878',
        color: '#fff',
        fontWeight: '800',
        boxShadow: '0 8px 28px rgba(0,0,0,.24)',
        opacity: '0',
        transition: 'opacity .18s ease'
      });
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.opacity = '1';
    clearTimeout(toast._opTimer);
    toast._opTimer = setTimeout(() => { toast.style.opacity = '0'; }, 3600);
  };

  const leadLabel = (minutes) => {
    const map = {30:'30 min',120:'2 h',1440:'24 h',2880:'48 h',10080:tr.day7};
    return map[Number(minutes)] || (String(minutes) + ' min');
  };

  const syncAll = () => {
    document.querySelectorAll('[data-reminder-event],[data-reminder-championship]').forEach(syncButton);
    document.querySelectorAll('[data-reminder-lead]').forEach((select) => {
      select.value = String(read().leadMinutes);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-reminder-event],[data-reminder-championship]');
    if (!button) return;
    const type = button.hasAttribute('data-reminder-championship') ? 'championship' : 'event';
    const active = toggle(type, button.dataset.reminderId || '');
    syncAll();

    if (!active) {
      showFeedback(type === 'championship' ? tr.champDisabled : tr.eventDisabled);
      return;
    }

    const lead = leadLabel(read().leadMinutes);
    if (type === 'event') {
      showFeedback(tr.eventOn + ' · ' + lead + ' ' + tr.before + '. ' + tr.eventFeedback);
    } else {
      showFeedback(tr.champOn + ' · ' + lead + ' ' + tr.before + '. ' + tr.champFeedback);
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-reminder-lead]');
    if (!select) return;
    setLeadMinutes(select.value);
    syncAll();
    showFeedback(tr.leadChanged + ' ' + leadLabel(select.value) + ' ' + tr.before + '.');
  });

  window.addEventListener('op:sport-reminders-changed', syncAll);
  document.addEventListener('shopify:section:load', syncAll);

  window.OPSportReminders = {
    get: read,
    has,
    toggle,
    getLeadMinutes: () => read().leadMinutes,
    setLeadMinutes
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
})();